import { useMutation, useQueryClient } from 'react-query';
import api from '@shared/api';
import { useDispatch } from 'react-redux';
import { dialogTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';

const deleteSlackConnection = async (organizationId: string) => {
  const { data } = await api.delete(
    `/slack/setup?organizationId=${organizationId}`
  );

  return data;
};

export function useSlackConnectionDisconnect() {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    (organizationId: string) => {
      return deleteSlackConnection(organizationId);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['slack-connection-status']);
      },
      onError: () => {
        dispatch(
          alertsUtil.openErrorDialog(
            dialogTypes.CATCH_ERROR_API,
            'There was an error disconnecting slack.'
          )
        );
      }
    }
  );
}
